import { createApiClient } from 'commons/http/createApiClient';
import { config } from 'config';

const bffAxiosInstance = createApiClient(config.api.bff);

export default bffAxiosInstance;
